/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class GroupService  {
  groups: any[];
  onGroupChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getGroups()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getGroups () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/group/groups'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.groups = response;
          this.onGroupChanged.next(this.groups);
          resolve(response);
        }, reject);
    });

  }

  getGroupnById(id) {
    return this.http.get(this.api.baseUrl + '/group/group?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteGroup(id) {
    return this.http.delete(this.api.baseUrl + '/group/deleteGroup?id=' + id , this.api.jsonTokenHeaders);
  }

  addGroup(data) {
    return this.http.post(this.api.baseUrl + '/group/addGroup' , data , this.api.formDataHeaders);
  }
}
